export default __webpack_public_path__ + "621e177f1b5422e8e68a3239b0413459.png";